import { useRef, useEffect } from 'react';
/**
 * Hook que nos permite conservar un valor y devolver su valor previo.
 */
export default function usePrevious(value) {
  const ref = useRef();
  useEffect(() => {
    ref.current = value;
  }, [value]);
  return ref.current;
}
